module.exports = __webpack_public_path__ + "static/icon-logo-62367c59bc83ebcd588f9d9f4d55790b.svg";